import { call, put, takeLatest } from "redux-saga/effects";
import toast from "react-hot-toast";
import * as types from "../actions/actionTypes";
import { axiosGet, axiosPost, axiosPut, axiosDelete } from "../../utils/common/axios";
import { 
  getAllAddressResponse, getAddressByIdResponse, getAddressByCustomerIdResponse 
} from "../actions";

export function* createAddressEffectSaga(action) {
  try {
    const { data } = yield call(() => axiosPost(`address`, action.data?.payload));
    action.data?.callback?.success?.(data);
    toast.success(data?.message || "Address saved successfully");
  } catch (e) {
    console.log(e);
    if (e?.status !== 401) action.data?.callback?.failure?.(e);
  }
}

export function* updateAddressEffectSaga(action) {
  try {
    const { data } = yield call(() => axiosPut(`address/2`, action.data?.payload));
    action.data?.callback?.success?.(data);
    toast.success(data?.message || "Address updated successfully");
  } catch (e) {
    console.log(e);
    if (e?.status !== 401) action.data?.callback?.failure?.(e);
  }
}

export function* getAllAddressEffectSaga(action) {
  try {
    const { data } = yield call(() => axiosGet(`address/all`));
    yield put(getAllAddressResponse(data));
    action?.payload?.callback?.success?.(data);
  } catch (e) {
    console.log(e);
    yield put(getAllAddressResponse([]));
  }
}

export function* getAddressByIdEffectSaga(action) {
  try {
    const { data } = yield call(() => axiosGet(`address/2`));
    yield put(getAddressByIdResponse(data));
    action?.payload?.callback?.success?.(data);
  } catch (e) {
    console.log(e);
    yield put(getAddressByIdResponse([]));
  }
}

export function* deleteAddressEffectSaga(action) {
  try {
    const { data } = yield call(() => axiosDelete(`address/3`));
    action.payload?.callback?.success?.(data);
    toast.success(data?.message || "Address deleted successfully");
  } catch (e) {
    console.log(e);
    if (e?.status !== 401) action.payload?.callback?.failure?.(e);
  }
}

export function* getAddressByCustomerIdEffectSaga(action) {
  try {
    const { data } = yield call(() => axiosGet(`address/customer/7`));
    yield put(getAddressByCustomerIdResponse(data));
    action?.payload?.callback?.success?.(data);
  } catch (e) {
    console.log(e);
    yield put(getAddressByCustomerIdResponse([]));
  }
}

export function* addressWatcherSaga() {
  yield takeLatest(types.CREATE_ADDRESS, createAddressEffectSaga);
  yield takeLatest(types.UPDATE_ADDRESS, updateAddressEffectSaga);
  yield takeLatest(types.GET_ALL_ADDRESS, getAllAddressEffectSaga);
  yield takeLatest(types.GET_ADDRESS, getAddressByIdEffectSaga);
  yield takeLatest(types.DELETE_ADDRESS, deleteAddressEffectSaga);
  yield takeLatest(types.GET_ADDRESS, getAddressByCustomerIdEffectSaga);
}
